import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

export default function LogsAdmin() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("logs_admin")
        .select("*, admins(email, nome)")
        .order("created_at", { ascending: false })
        .limit(100);

      if (queryError) {
        console.error("Erro ao buscar logs:", queryError);
        setError(queryError.message);
        setLogs([]);
      } else {
        setLogs(data || []);
      }
    } catch (err) {
      console.error("Erro inesperado:", err);
      setError("Erro ao carregar dados");
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const formatAction = (acao) => {
    const actions = {
      aprovar_empresa: "Aprovou empresa",
      rejeitar_empresa: "Rejeitou empresa",
      aprovar_avaliacao: "Aprovou avaliacao",
      rejeitar_avaliacao: "Rejeitou avaliacao",
      aprovar_vaga: "Aprovou vaga",
      rejeitar_vaga: "Rejeitou vaga"
    };
    return actions[acao] || acao;
  };

  return (
    <div>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "1.5rem" }}>
        Logs de Atividades
      </h1>

      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p style={{ color: "#dc2626" }}>Erro: {error}</p>
      ) : logs.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Nenhum log registrado.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          {logs.map((log) => (
            <div key={log.id} style={{
              backgroundColor: "#fff",
              borderRadius: "6px",
              padding: "1rem",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <div>
                <span style={{ fontWeight: "500" }}>{log.admins?.nome || log.admins?.email}</span>
                <span style={{ color: "#6b7280" }}> {formatAction(log.acao)}</span>
                {log.motivo && (
                  <p style={{ fontSize: "0.75rem", color: "#dc2626", marginTop: "0.25rem" }}>
                    Motivo: {log.motivo}
                  </p>
                )}
              </div>
              <span style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
                {new Date(log.created_at).toLocaleString("pt-BR")}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
